import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button, Form, Icon, Input } from "semantic-ui-react";

import "modules/Login/components/ResetPasswordRequest/ResetPasswordRequest.scss";
import { useResetPasswordRequestMutation } from "modules/Login/components/ResetPasswordRequest/useResetPasswordRequestMutation";
import { validateEmail } from "utils/common";

export const ResetPasswordRequest = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const { mutate: resetPasswordRequestMutation, isPending, isSuccess, isError } = useResetPasswordRequestMutation();

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validateEmail(email)) return;

    resetPasswordRequestMutation(email);
  };

  return (
    <div className="ResetPasswordRequest">
      <div className="header">
        <p>{t("v8_reset_password", "Reset Password")}</p>
        <Link to={`/login`} className="backBtn">
          <Icon className="angle left" />
          {t("v8_back_to_login", "Back to Login")}
        </Link>
      </div>
      <div className="mt-15">
        {!isSuccess && !isError && (
          <Form onSubmit={onSubmit}>
            <Form.Field>
              <Input
                name="email"
                id="email"
                value={email}
                onChange={onInputChange}
                icon="mail"
                iconPosition="left"
                type="text"
                placeholder={t("v8_email", "Email")}
                required
                className="icon-green"
              />
            </Form.Field>
            <div className="mt-25">
              <Button disabled={isPending} loading={isPending} type="submit" id="submit-reset-password" color="green" fluid>
                {t("v8_reset_password", "Reset Password")}
              </Button>
            </div>
          </Form>
        )}
        {isSuccess && (
          <div className="success">
            {t("v8_email_sent_with_instructions", "You will receive an email with instructions if an account is registered with the provided email address.")}
          </div>
        )}
        {isError && <div className="error">{t("v8_unexpected_error", "An unexpected error has occurred.")}</div>}
      </div>
    </div>
  );
};
